import React from 'react'
import logo from '../../../assets/static/reclameaqui-verificado.png'

const LogotipoReclameAqui = () => (
	<img className="logoReclameAqui" 
	src={logo}
	alt="Logotipo Reclame Aqui"
	height="110px"
	width = "110px" />
)

export default LogotipoReclameAqui
